import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M4.838 9.838l.849.849a4.632 4.632 0 0 1 6.626 0l.849-.849C12.101 8.762 10.627 8.093 9 8.093s-3.101.669-4.162 1.745zM9 5.343a8.574 8.574 0 0 0-6.106 2.552l.848.848c1.342-1.357 3.203-2.2 5.258-2.2s3.916.843 5.258 2.2l.848-.848A8.57 8.57 0 0 0 9 5.343zm-2.217 6.44l.848.848c.346-.361.83-.589 1.369-.589s1.023.228 1.369.589l.848-.848a3.088 3.088 0 0 0-4.434 0zM9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0zm0 16.8c-4.301 0-7.8-3.499-7.8-7.8S4.699 1.2 9 1.2s7.8 3.499 7.8 7.8-3.499 7.8-7.8 7.8z" />
  </svg>
);

export default SvgComponent;
